<template>
  <w-autocomplete
    class='w-multiple-selection-filter'
    v-bind='filterProps($props, ["items"])'
    :items='sortedItems'
    hide-selected
    v-on='$listeners'
  >
    <template
      v-if='filterHasFilterOptions'
      #append
    >
      <MultipleSelectionFilterMenu
        :filter-options='filterOptions'
        :filter-option-text='filterOptionText'
        :option-select-disabled='optionSelectDisabled'
        @click:filterOption='handleFilterOption'
      />
    </template>
  </w-autocomplete>
</template>

<script>
import WorkAutocomplete from '@/components/global_components/forms/WorkAutocomplete';
import multipleSelectionMixin from "@/components/global_components/filters/multiple_selection_filter/shared/multiple-selection-mixin";
import { filterProps } from "@/utils/functional-component-utils";
import sortedItems from "@/mixins/component/sorted-items-mixin";

export default {
  name: 'WorkMultipleSelectionFilter',
  components: { MultipleSelectionFilterMenu: () =>
    import('@/components/global_components/filters/multiple_selection_filter/shared/MultipleSelectionFilterMenu')
  },
  mixins: [multipleSelectionMixin(WorkAutocomplete.props), sortedItems],
  methods: {
    filterProps: filterProps
  }
};
</script>
